import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const AutomationMarkForTranslationInputI18n = {
  configuration: { namespace: I18nNamespace.AUTOMATION_MARK_FOR_TRANSLATION_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.automaticallyMarkForTranslation,
  },
};
